import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setExceptionHandler } from '@app/store/actions';
import { basicService } from '@app/services';
import { } from '@app/components';
import { Fade } from '@material-ui/core';
import ReadyToSetup from './readyToSetup.component';
import DownloadInstaller from './downloadInstaller.component';
import ConnectOU from './connectOUs.component';
import ConfigureAgent from './configureAgent.component';
import SyncSummary from './syncSummary.component';
import ContactAdmin from './contactAdmin.component';
import { defaultOrgId, store } from '@app/helpers';

const SyncOnboardingStartPage = () => {
    // -------------------------------------------
    // ------------------ DATA -------------------
    // -------------------------------------------
    const [currentStep, setCurrentStep] = useState(1);
    const [agentId, setAgentId] = useState('');

    const dispatch = useDispatch();

    // -------------------------------------------
    // ----------------- EFFECTS -----------------
    // -------------------------------------------
    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, []);

    // -------------------------------------------
    // --------------- FUNCTIONS -----------------
    // -------------------------------------------
    const onNext = () => {
        setCurrentStep(currentStep + 1);
    };

    const onClose = () => {
        basicService.redirect('/directory/sync');
    }

    return (
        <>
            {currentStep === 1 &&
                <Fade in={true}
                    timeout={1000}>
                    <div>
                        <ReadyToSetup onNext={onNext} />
                    </div>
                </Fade>
            }

            {currentStep === 2 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <DownloadInstaller onNext={onNext} onCancel={onClose} setAgent={setAgentId} />
                    </div>
                </Fade>
            }

            {currentStep === 3 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <ConnectOU onNext={onNext} onCancel={onClose} agentId={agentId} />
                    </div>
                </Fade>
            }

            {currentStep === 4 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <ConfigureAgent onNext={onNext} onCancel={onClose} agentId={agentId} />
                    </div>
                </Fade>
            }

            {currentStep === 5 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <SyncSummary onClose={onClose} />
                    </div>
                </Fade>
            }

            {currentStep === 6 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <ContactAdmin onClose={onClose} />
                    </div>
                </Fade>
            }
        </>
    );
};

export default SyncOnboardingStartPage;
